import { CATALOG_UNSTABLE_API_V2, NEW_ADMIN_INVOICES } from 'App/featuresFlags';
import { useHasTags } from '..';

function useCanUseUnstableApiV2(): boolean {
  const [hasUnstableApiV2, hasInvoicesBR] = useHasTags([
    CATALOG_UNSTABLE_API_V2,
    NEW_ADMIN_INVOICES,
  ]);
  return hasUnstableApiV2 && !hasInvoicesBR;
}

export default useCanUseUnstableApiV2;
